import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';
import { Typography, Fade, makeStyles } from '@material-ui/core';
import CustomButton from '../customButton';
import TagsCategory from '../tagsCategory';
import NotificationCard from '../notificationCard';
import ConditionalTooltip from '../conditionalTooltip';
import { isArrayEmpty } from '../../../utility/helpers';

const useStyles = makeStyles(({ spacing }) => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: spacing(8),
    width: '100%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing(3),
  },
  title: {
    marginBottom: spacing(2),
  },
  description: {
    width: 500,
  },
  category: {
    marginBottom: spacing(4),
    '&:last-of-type': {
      marginBottom: 0,
    },
  },
  disabledUserAction: {
    cursor: 'not-allowed',
  },
}));

const UserTagsInfo = ({
  translations,
  categories,
  isUserDeactivated,
  canAddTags,
  onAddButton,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.main}>
      <div className={classes.header}>
        <div>
          <Typography variant="h5" className={classes.title}>
            {translations.tagsInfo}
          </Typography>
          <Typography className={classes.description} variant="body2">
            {translations.tags.description}
          </Typography>
        </div>
        {canAddTags && (
          <ConditionalTooltip
            className={classes.disabledUserAction}
            message={translations.disabledTagsActionTooltip}
            addTooltip={isUserDeactivated}
          >
            <CustomButton
              type="addDarkRoundedOutlined"
              disabled={canAddTags && isUserDeactivated}
              onClick={onAddButton}
            >
              {translations.add}
            </CustomButton>
          </ConditionalTooltip>
        )}
      </div>
      {!isArrayEmpty(categories) ? (
        <TransitionGroup>
          {categories.map(category => (
            <Fade
              key={`category_${category.id}`}
              className={classes.category}
              in
              appear
            >
              <div>
                <TagsCategory translations={translations} category={category} />
              </div>
            </Fade>
          ))}
        </TransitionGroup>
      ) : (
        <NotificationCard content={translations.noTags} />
      )}
    </div>
  );
};

UserTagsInfo.propTypes = {
  translations: PropTypes.object.isRequired,
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  canAddTags: PropTypes.bool.isRequired,
  isUserDeactivated: PropTypes.bool.isRequired,
  onAddButton: PropTypes.func.isRequired,
};

export default UserTagsInfo;
